export function mapInstrumentNameToGroupKey(exchange, instrumentName) {
    if (!instrumentName || !exchange) return null;
    const ex = exchange.toUpperCase();
    const name = instrumentName.toUpperCase();
    const mapping = {
        NSE: [
            { regex: /^EQ$/, group: 'EQUITY' }
        ],
        NFO: [
            { regex: /^FUT/, group: 'FUTURE' },
            { regex: /^OPT/, group: 'OPTION' },
            { regex: /^IND$/, group: 'INDICES' }
        ],
        MCX: [
            { regex: /^FUT/, group: 'FUTURE' },
            { regex: /^OPT/, group: 'OPTION' }
        ],
        CDS: [
            { regex: /^FUT/, group: 'FUTURE' }
        ],
        CDSX: [
            { regex: /^FUT/, group: 'FUTURE' },
            { regex: /^OPT/, group: 'OPTION' }
        ]
    };

    if (mapping[ex]) {
        for (const rule of mapping[ex]) {
            if (rule.regex.test(name)) {
                return rule.group;
            }
        }
    }
    return name;
}

export async function calculateBrokerageValueAsync({ exchange, token, brokerageData, quantity, price, orderType, orderSide, marketData, instrument_name }) {
    if (!exchange || !token || !brokerageData || !brokerageData.grouped) return 0;
    const instrumentName = instrument_name;
    if (!instrumentName) return 0;

    const groupKey = mapInstrumentNameToGroupKey(exchange, instrumentName);
    if (!groupKey) return 0;

    const grouped = brokerageData.grouped;
    const matchedTypeKey = Object.keys(grouped).find(
        typeKey => typeKey.toUpperCase() === groupKey.toUpperCase()
    );
    if (!matchedTypeKey) return 0;
    const rulesForType = grouped[matchedTypeKey];
    if (!Array.isArray(rulesForType) || rulesForType.length === 0) return 0;
    const matchingRule = rulesForType.find(
        rule => rule.exchange.toUpperCase() === exchange.toUpperCase() && rule.is_active === true
    );
    if (!matchingRule) return 0;
    const matchedBrokerageValue = Number(matchingRule.brokerage_value) || 0;
    const qty = Number(quantity) || 0;
    let prc = 0;
    if (orderType === 'MARKET') {
        if (orderSide === 'BUY') {
            prc = parseFloat(marketData.bestAsk) || 0;
        } else if (orderSide === 'SELL') {
            prc = parseFloat(marketData.bestBid) || 0;
        }
    }
    if (!prc) {
        prc = parseFloat(price) || 0;
    }
    if (!matchedBrokerageValue || !qty || !prc) return 0;
    return (matchedBrokerageValue * qty * prc) / 100;
}